import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { auth, AuthContext } from 'libs/shared-firebase/src';
import log from 'loglevel';
import Head from 'next/head';
import React, { useEffect, useState } from 'react';
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import { useAuthState } from 'react-firebase-hooks/auth';
import { QueryClient, QueryClientProvider } from 'react-query';
import { createGlobalStyle, ThemeProvider } from 'styled-components';
import 'tippy.js/dist/tippy.css';
import '../styles/globals.css';
import { colors, DefaultFont, fontSizes, themes } from '../styles/themes';
import useUnloadHypothesis from '../utils/unloadHypothesis';
import { useAnalytics } from '../utils/useAnalytics';
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\nhtml{\n  background-color: ",
        ";\n  font-size:16px;\n  /* responsively change root font size */\n  @media only screen and (max-width: 700px) {\n    font-size:14px;\n  }\n  @media only screen and (max-width: 500px) {\n    font-size:13px;\n  }\n}\nbody{\n  overflow-x:hidden; \n    background-color: ",
        ";\n\n  color:",
        ";\n}\n\nh1,h2,h3,h4,h5,h6{\n  font-family:",
        ";\n  color:",
        ";\n}\n\n::-webkit-scrollbar {\n    background-color: ",
        ";\n  }\n  ::-webkit-scrollbar-thumb{\n    background-color: ",
        ";\n  }\n\n/* this style is neccessary for slate rewrite */\n.selectedtag {\n    background-color: ",
        ";\n  } \n\n  .slate-h1,.slate-h2,.slate-h3{\n    margin-top:0px;\n  }\n\n@keyframes spinner {\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n/* some hacky shit */\n[data-tippy-root]{\n  display:inline;\n}\n\n.slate-MentionSelect{\n  padding:0px;\n  border-radius:0px;\n  background-color:none;\n}\n\n.slate-MentionSelect-mentionItem,.slate-MentionSelect-mentionItemSelected{\n  background-color:",
        ";\n  border-radius:0px;\n}\n\n.slate-MentionSelect-mentionItem:hover{\n  background-color:",
        ";\n}\n\n.slate-MentionSelect-mentionItemSelected{\n  background-color:",
        ";\n}\n\n/* this is jank, but fuck it. hover styling for static mentions */\n[data-mention=\"serializedMention\"]:hover{\n  outline:2px solid blue;\n}\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
export var queryClient = new QueryClient(); // for the mentionComponent
export var mouseDown = false;
var setDown = function() {
    mouseDown = true;
};
var setUp = function() {
    mouseDown = false;
};
log.setDefaultLevel('silent'); // if (process.env.NEXT_PUBLIC_DEV) {
//   log.enableAll();
// }
function MyApp(param) {
    var Component = param.Component, pageProps = param.pageProps;
    var ref = useState(themes.DEFAULT_THEME), theme = ref[0], setTheme = ref[1];
    var ref1 = useState(fontSizes[1][1]), fontSize = ref1[0], setFontSize = ref1[1];
    var ref2 = _slicedToArray(useAuthState(auth), 3), user = ref2[0], authLoading = ref2[1], authError = ref2[2];
    useUnloadHypothesis();
    useAnalytics();
    useEffect(function() {
        var userTheme = window.localStorage.getItem('theme');
        var userFontSize = window.localStorage.getItem('fontSize');
        if (userTheme && themes[userTheme]) {
            setTheme(themes[userTheme]);
        }
        if (userFontSize && fontSizes[parseInt(userFontSize)]) {
            setFontSize(fontSizes[parseInt(userFontSize)][1]);
        } // // set up logger
    // window.log = log;
    }, []);
    useEffect(function() {
        document.addEventListener('mousedown', setDown);
        document.addEventListener('mouseup', setUp);
        return function() {
            document.removeEventListener('mousedown', setDown);
            document.removeEventListener('mouseup', setUp);
        };
    }, []);
    var Layout = Component.layout || function(props) {
        /*#__PURE__*/ return _jsx(_Fragment, {
            children: props.children
        });
    };
    return(/*#__PURE__*/ _jsx(QueryClientProvider, {
        client: queryClient,
        children: /*#__PURE__*/ _jsxs(DndProvider, {
            backend: HTML5Backend,
            children: [
                /*#__PURE__*/ _jsxs(Head, {
                    children: [
                        /*#__PURE__*/ _jsx("meta", {
                            name: "viewport",
                            content: "width=device-width, initial-scale=1, maximum-scale=1"
                        }),
                        /*#__PURE__*/ _jsx("title", {
                            children: "exegesis"
                        })
                    ]
                }),
                /*#__PURE__*/ _jsxs(ThemeProvider, {
                    theme: _objectSpread({}, theme, {
                        fontSize: fontSize
                    }),
                    children: [
                        /*#__PURE__*/ _jsx(GlobalStyle, {}),
                        /*#__PURE__*/ _jsx(AuthContext.Provider, {
                            value: {
                                loggedInUser: user,
                                authLoading: authLoading
                            },
                            children: /*#__PURE__*/ _jsx(Layout, {
                                children: /*#__PURE__*/ _jsx(Component, _objectSpread({}, pageProps, {
                                    setTheme: setTheme,
                                    setFontSize: setFontSize
                                }))
                            })
                        })
                    ]
                })
            ]
        })
    }));
}
var GlobalStyle = createGlobalStyle(_templateObject(), function(props) {
    return props.theme.backgroundColor || 'transparent';
}, function(props) {
    return props.theme.backgroundColor || 'transparent';
}, colors.offBlack, function(props) {
    return props.theme.headerFont || DefaultFont;
}, colors.offBlack, function(props) {
    return props.theme.scrollbarColor;
}, function(props) {
    return props.theme.scrollbarThumbColor;
}, function(props) {
    return props.theme.colors.main.dark;
}, function(props) {
    return props.theme.colors.main.medium;
}, function(props) {
    return props.theme.colors.main.dark;
}, function(props) {
    return props.theme.colors.main.dark;
});
export default MyApp;
